import { useQuery } from '@tanstack/react-query';

import { format, subtractDays } from '@shared/utils/time';
import { DATE_FORMAT } from '@shared/utils/time/constants';

import { fetchBankHolidaysAndSpecialDays } from '@ManagerPortal/api/schedule';
import { reactQueryFetchingToggle } from '@ManagerPortal/featureToggles';

import { SCHEDULE_DATA_CACHE_TIME } from '../useFetchScheduleData';
import { useGetScheduleDataHookParams } from '../utils/useGetScheduleDataHookParams';

export const QUERY_KEY = '/v1/bank-holidays/with-special-days/by-group/';

export const useBankHolidaysAndSpecialDaysQuery = () => {
  const {
    isPlaceholderFilterData,
    currentGroupId: groupId,
    start,
    end,
  } = useGetScheduleDataHookParams();

  const from = format(start, DATE_FORMAT);
  const to = format(subtractDays(end, 1), DATE_FORMAT);
  const params = [groupId, from, to] as const;

  const bankHolidaysAndSpecialDaysQuery = useQuery({
    queryKey: [QUERY_KEY, ...params],
    queryFn: async () => {
      const response = await fetchBankHolidaysAndSpecialDays(...params);
      return response?.body;
    },
    enabled: !isPlaceholderFilterData && reactQueryFetchingToggle,
    cacheTime: SCHEDULE_DATA_CACHE_TIME,
  });

  return bankHolidaysAndSpecialDaysQuery;
};
